<script setup>
import { computed } from 'vue';
import BusinessDay from '../../inbox/components/BusinessDay.vue';

const DAY_NAMES = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

const props = defineProps({
  modelValue: { type: Array, required: true },
  title: { type: String, default: 'Horário de atendimento' },
  helper: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

const toAmPm = (h, m) => {
  if (h == null || m == null) return '';
  const hr = Number(h);
  const period = hr >= 12 ? 'PM' : 'AM';
  const display = hr % 12 === 0 ? 12 : hr % 12;
  const minStr = String(m).padStart(2, '0');
  return `${String(display).padStart(2, '0')}:${minStr} ${period}`;
};

const parseAmPm = str => {
  if (!str) return { hour: null, minutes: null };
  const m = String(str).match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!m) return { hour: null, minutes: null };
  let hour = parseInt(m[1], 10);
  const mins = parseInt(m[2], 10);
  const period = m[3].toUpperCase();
  if (period === 'AM' && hour === 12) hour = 0;
  if (period === 'PM' && hour < 12) hour += 12;
  return { hour, minutes: mins };
};

const slots = computed(() =>
  (props.modelValue || []).map(s => {
    const closed = !!s.closed_all_day;
    const openAllDay = !!s.open_all_day;
    let fromStr = '';
    let toStr = '';

    if (!closed) {
      fromStr = openAllDay ? '12:00 AM' : toAmPm(s.open_hour, s.open_minutes);
      toStr = openAllDay ? '11:59 PM' : toAmPm(s.close_hour, s.close_minutes);
    }

    return {
      day_of_week: s.day_of_week,
      from: fromStr,
      to: toStr,
      valid: true,
      openAllDay,
    };
  })
);

const handleSlotUpdate = (index, payload) => {
  const next = (props.modelValue || []).map(x => ({ ...x }));
  const from = parseAmPm(payload.from);
  const to = parseAmPm(payload.to);
  const isClosed = !payload.openAllDay && (!payload.from || !payload.to);
  next[index] = {
    ...next[index],
    closed_all_day: isClosed,
    open_all_day: !!payload.openAllDay,
    open_hour: isClosed ? null : from.hour,
    open_minutes: isClosed ? null : from.minutes,
    close_hour: isClosed ? null : to.hour,
    close_minutes: isClosed ? null : to.minutes,
  };
  emit('update:modelValue', next);
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <div v-if="title || helper" class="flex flex-col gap-1">
      <h3 v-if="title" class="text-body-large text-n-slate-12 font-medium m-0">{{ title }}</h3>
      <p v-if="helper" class="text-body-small text-n-slate-11 m-0">{{ helper }}</p>
    </div>
    <div class="border border-n-strong rounded-lg overflow-hidden bg-n-background">
      <table class="w-full">
        <tbody>
          <BusinessDay
            v-for="(slot, idx) in slots"
            :key="slot.day_of_week"
            :day-name="DAY_NAMES[slot.day_of_week] || `Dia ${slot.day_of_week}`"
            :time-slot="slot"
            @update="payload => handleSlotUpdate(idx, payload)"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>
